import { render, staticRenderFns } from "./HighlightElement.vue?vue&type=template&id=20e87b7d&scoped=true&lang=pug&"
import script from "./HighlightElement.vue?vue&type=script&lang=js&"
export * from "./HighlightElement.vue?vue&type=script&lang=js&"
import style0 from "./HighlightElement.vue?vue&type=style&index=0&id=20e87b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e87b7d",
  null
  
)

export default component.exports